import React from "react";
import { createRoot } from "react-dom/client";
import "./global.css";
import reportWebVitals from "./reportWebVitals";

import AppRoutes from "./setup/AppRoutes";
import { I18nextProvider } from "react-i18next";
import i18n from "./setup/i18n";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const container: any = document.getElementById("root");
const root = createRoot(container);
const queryClient = new QueryClient();
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <AppRoutes />
      </QueryClientProvider>
    </I18nextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
